import { DeleteOutline, DownloadOutlined } from "@mui/icons-material";
import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import Alert from "components/alert";
import { setLoading } from "lib/Reducer/loadingSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { invoiceBulkAction } from "../api/commissions";

const BulkActions = ({
  selectedRows,
  setSelectedRows,
  setReload,
  paymentMethods,
  expenseCategories,
  customers,
  projects,
}) => {
  const [alert, setAlert] = useState({ status: false, data: null });

  const dispatch = useDispatch();
  const handleBulkAction = async (type, data) => {
    setAlert({ status: false, data: null });
    dispatch(setLoading(true));
    const obj = { selected_ids: selectedRows, action: type };
    if (type === "export") obj.trash_export = false;
    obj[type] = data;
    try {
      const result = await invoiceBulkAction({ body_data: obj });
      if (result?.data?.file) window.open(result?.data?.file);
    } finally {
      dispatch(setLoading(false));
      setReload((pre) => !pre);
    }
  };

  return (
    <Box
      p="10px 20px 10px"
      sx={{
        borderTop: "1px solid #efefef",
        bgcolor: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "18px",
        backgroundColor: "#e3eefa",
      }}
    >
      {alert?.status && (
        <Alert
          open={alert?.status}
          handleClose={() => setAlert({ status: false, data: null })}
          title="Delete Selected Invoice"
          desc="Are you sure you want to delete? Don't worry you will find these invoices on Trash Menu"
          buttons={
            <>
              <Button
                onClick={() => {
                  setAlert({ status: false, data: null });
                  setSelectedRows([]);
                }}
              >
                No, keep it
              </Button>
              <Button
                variant="solid"
                onClick={() => handleBulkAction(alert.data)}
              >
                Yes, delete it
              </Button>
            </>
          }
        />
      )}
      <Typography variant="h5">{selectedRows?.length} Selected</Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <TextField
          sx={{ width: "200px" }}
          size="small"
          label="Change Category"
          select
          onChange={(e) =>
            handleBulkAction("expense_category_id", e.target.value)
          }
        >
          {expenseCategories?.length ? (
            expenseCategories?.map((ec) => (
              <MenuItem value={ec.id}>{ec.name}</MenuItem>
            ))
          ) : (
            <MenuItem disabled>No category available</MenuItem>
          )}
        </TextField>
        <TextField
          sx={{ width: "200px" }}
          size="small"
          label="Payment Method"
          select
          onChange={(e) =>
            handleBulkAction("payment_method_id", e.target.value)
          }
        >
          {paymentMethods?.length ? (
            paymentMethods?.map((pm) => (
              <MenuItem value={pm.id}>{pm.name}</MenuItem>
            ))
          ) : (
            <MenuItem disabled>No pay method available</MenuItem>
          )}
        </TextField>
        <TextField
          sx={{ width: "190px" }}
          size="small"
          label="Change customer"
          select
          onChange={(e) => handleBulkAction("customer_id", e.target.value)}
        >
          {customers?.length ? (
            customers?.map((customer) => (
              <MenuItem value={customer.id}>{customer.name}</MenuItem>
            ))
          ) : (
            <MenuItem disabled>No customer available</MenuItem>
          )}
        </TextField>
        <TextField
          sx={{ width: "190px" }}
          size="small"
          label="Change Project"
          select
          onChange={(e) => handleBulkAction("project_id", e.target.value)}
        >
          {projects?.length ? (
            projects?.map((project) => (
              <MenuItem value={project.id}>{project.name}</MenuItem>
            ))
          ) : (
            <MenuItem disabled>No project available</MenuItem>
          )}
        </TextField>
        <Button
          variant="solid"
          onClick={() => setAlert({ status: true, data: "trash" })}
          startIcon={<DeleteOutline />}
        >
          Delete
        </Button>
        <Button
          variant="solid"
          onClick={() => handleBulkAction("export")}
          startIcon={<DownloadOutlined />}
        >
          Export
        </Button>
      </Box>
    </Box>
  );
};

export default BulkActions;
